export default "__VITE_ASSET__CMLysrGj__"